export default function GS_Format_Borders() {
  return (
    <div className="p-4">
      <h1>GS Format Borders</h1>
    </div>
  );
}
